// import logo from './logo.svg';
import React from "react";
// import { Button, Flex } from "antd";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  // useHistory,
  // Link,
} from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
// import { ExclamationCircleOutlined } from "@ant-design/icons";
// Import Routes
import { authProtectedRoutes, publicRoutes } from "./routes/index";
// import { authProtectedRoutes, publicRoutes } from "./routes/index"
import AppRoute from "./routes/route";

import "./App.css";
import NotFoundPage from "./pages/NotFoundPage/index";
import NonAuthLayout from "./components/NonAuthLayout";
import Layout from "./components/Layout/index";
// import { Modal } from "antd";

// import MainLayout from "./components/Layout/layout";
// import NonAuthLayout from "./pages/NonAuthLayout";

function App(props) {
  // const history = useHistory();
  // const [confirmation, setConfirmation] = useState(false);
  // const getLayout = () => {
  //   let layoutCls = MainLayout;

  //   switch (props.layout.layoutType) {
  //     case "horizontal":
  //       layoutCls = MainLayout;
  //       break;
  //     default:
  //       layoutCls = MainLayout;
  //       break;
  //   }
  //   return layoutCls;
  // };

  // console.log(props, "props");

  // const Layout = getLayout();

  // useEffect(() => {
  //   navigator.geolocation.getCurrentPosition(function (position) {
  //     console.log("Latitude is :", position.coords.latitude);
  //     console.log("Longitude is :", position.coords.longitude);
  //   });
  //   if (navigator.geolocation) {
  //     navigator.permissions
  //       .query({ name: "geolocation" })
  //       .then(function (result) {
  //         console.log(result);
  //       });
  //   } else {
  //     console.log("Geolocation is not supported by this browser.");
  //   }
  // }, []);
  return (
    <div className="App">
      {/* <Layout> */}

      <React.Fragment>
        <Router
          // getUserConfirmation={(message, callback) => {
          //   // setConfirmation(true);
          //   // console.log("open modal here!");

          //   const allowTransition = window.confirm(message);
          //   window.setTimeout(() => {
          //     callback(allowTransition);
          //   }, 1000);
          // }}
        >
          <Switch>
            {authProtectedRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={true}
                exact={true}
                {...route}
              />
            ))}
            {publicRoutes.map((route, idx) => (
              <AppRoute
                path={route.path}
                layout={NonAuthLayout}
                // layout={Layout}
                component={route.component}
                key={idx}
                isAuthProtected={false}
                {...route}
              />
            ))}

            <Route path="*" exact component={NotFoundPage} />
          </Switch>
          {/* <Modal
            open={confirmation}
            onOk={() => {
              setConfirmation(false);
            }}
            closeIcon
            maskClosable={false}
            rootClassName="p-15 h-[300px]"
            okText={"Yes, Leave"}
            cancelText={"No, Stay"}
            onCancel={() => setConfirmation(false)}
            footer={(_, { OkBtn, CancelBtn }) => (
              <div className="text-center flex justify-center">
                <div className="mr-3">
                   <Link
                    to={{
                      pathname: "/dashboard",
                    }}
                  > 
                    <OkBtn />
                  </Link> 
                </div>
                <CancelBtn />
              </div>
            )}
            width={500}
          >
            <div className="text-center w-[100%]">
              <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
              <h1 className="text-center text-[18px] font-bold">
                Are you sure you want to leave this page?
              </h1>
              <p className="text-center text-[14px] mt-2">
                All unsaved changes will be lost!
              </p>
            </div>
          </Modal> */}
        </Router>
      </React.Fragment>
      {/* </Layout> */}
    </div>
  );
}

const mapStateToProps = (state) => {
  return {
    layout: state.Layout,
  };
};

App.propTypes = {
  layout: PropTypes.object,
  location: PropTypes.any,
};

export default connect(mapStateToProps, null)(App);
